<template>
  <div
    @click="selItem(user)"
    :class="['card', 'canEdite', { sel: user._checked }]"
  >
    <div  :class="['Icon']">
      <span v-if="user.Icon" class="head"><img :src="user.Icon"></span>
      <span v-else class="head" :style="{background:user.Sex?'#4196ff':'#ff8c8c'}">{{xy.showName(user.FullName)}}</span>
    </div>
    <div class="name">
      <span :class="['Score']"> {{ isSettingGroup?user.Score:user.TotalScore }}</span>
      {{ user.FullName.substring(user.FullName.length-4) }}
    </div>
    <div v-show="user._checked" class="selspn"></div>
  </div>
</template>
<script>
export default {
  name: 'Card',
  props: {
    isSettingGroup: {
      type: Boolean,
      default: true
    },
    edite: {
      type: Boolean,
      default: false
    },
    index:{
      type: Number,
      default: 0
    },
    index1:{
      type: Number,
      default: 0
    },
    data:{
      type: Array
    },
    user: {
      type: Object,
      default() {
        return {
          FullName: '',
          _checked: '',
          Icon: '',
          Score: ''
        }
      }
    }
  },
  created() {
    // console.log(this.card)
  },
  mounted() {},
  methods: {
    selItem(item) {
      if (!this.edite) return
      item._checked = !item._checked
      if(this.isSettingGroup){
        this.updateDraft(this.data[this.index].StudentScoreInfo,this.index1,item._checked)
      }else{
        this.updateDraft(this.data[this.index],this.index,item._checked)
      }
    },
    // 更新视图
    updateDraft (tableData, index, field) {
      const obj = Object.assign({}, tableData[index])
      this.$set(tableData, index, {})
      for (var key in field) {
        obj[key] = field[key]
      }
      this.$set(tableData, index, obj)
    },
  }
}
</script>
<style lang='less' scoped>
.card {
  position: relative;
  width: 129px;
  height: 135px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid white;
  overflow: hidden;
  margin-bottom:10px;
  margin-right:8px;
}
.canEdite {
  border: 1px solid #d5d5d5;
}
.sel {
  border: 1px solid #1677ff;
}
.typeTitle {
  margin-top: 10px;
  line-height: 22px;
  // prettier-ignore
  font-size: 16Px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
}
.Icon {
  margin: 37px auto 0;
  width: 54px;
  height: 54px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    vertical-align: top;
  }
}
.name {
  position: relative;
  margin-top: 8px;
  // prettier-ignore
  font-size: 15Px;
  font-weight: 400;
  color: rgba(26, 26, 26, 0.85);
  vertical-align: top;
  text-align: center;
  .Score {
    position: absolute;
    // top: -10px;
    right: 15px;
    top:-90px;
    // prettier-ignore
    font-size: 18Px;
    font-weight: 500;
    text-align: left;
    color: #e28d30;
  }
  .more{
    top:-68px;
  }
}
.selspn {
  width: 31px;
  height: 31px;
  background: url('./img/sel.png');
  background-size: 62px;
  position: absolute;
  bottom: -2px;
  right: -2px;
}
.head {
    border:1px solid #fff;
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 54px;
    height: 54px;
    text-align: left;
    border-radius: 50%;
    background: @blue;
    font-size: 14px;
    color: #fff;
    > img {
      width: 100%;
      height: 100%;
      display: block;
      border-radius: 50%;
    }
  }
</style>
